import type { MapboxGeocodeResponse } from '$src/js/modules/mapbox/mapbox.d.ts';

export class MapboxService {
  protected MAPBOX_TOKEN =
    'pk.eyJ1IjoicmVhZHkycmFjZSIsImEiOiJjbTd2dWxoeXEwMDhnMnFyMDVjcXN2azFsIn0.OWaYQK_O4Rl87WyHQ1OM7g';

  async getGeoLocationFromString(
    string: string
  ): Promise<{ lng: number | null; lat: number | null; province: string | null }> {
    const response = await fetch(
      `https://api.mapbox.com/search/geocode/v6/forward?access_token=${this.MAPBOX_TOKEN}&types=place,postcode&bbox=2.38889,49.54205,7.31363,53.66589&limit=1&q=${string}`
    );
    const data = (await response.json()) as MapboxGeocodeResponse;
    const rawCoordinates = data.features[0]?.geometry?.coordinates;
    const province = data.features[0]?.properties?.context?.region?.name ?? null;

    if (!rawCoordinates || !Array.isArray(rawCoordinates)) {
      return {
        lng: null,
        lat: null,
        province: null,
      };
    }

    const [lng, lat] = rawCoordinates;

    return { lng, lat, province };
  }
}
